import clsx from 'clsx'

import { ChildProps } from '@/common/util/props'

/** 上下の境界線に敷くAIグラデーション（text-ai / border-ai と同じ配色） */
const AI_LINE_CLASS = 'bg-linear-to-r from-purple-800 via-[#cc00b7] to-red-700'

/** BG-AI：斜めの光が領域を横切る装飾 */
const AiShine = () => (
  <div
    className='pointer-events-none absolute top-1/2 left-1/2 size-full -translate-x-1/2 -translate-y-1/2 overflow-hidden'
    aria-hidden='true'
  >
    <span className='animate-shine absolute top-1/2 -left-1/4 size-[300%] -translate-x-1/2 -translate-y-1/2 -rotate-45 bg-linear-to-b from-transparent via-white/80 to-transparent motion-reduce:animate-none' />
  </div>
)

interface Props extends ChildProps {
  type?: 'default' | 'modal' | 'transparent'
}

const AiLoadingArea = ({ children, type = 'default' }: Props) => {
  /** 既存コンテンツの上に白の半透明で重ねる（親要素に relative が必要） */
  if (type == 'transparent') {
    return (
      <div className='bg-awayuki-800 absolute inset-0 z-10 flex flex-col items-center justify-center overflow-hidden'>
        <AiShine />
        <div className='relative'>{children}</div>
      </div>
    )
  }

  /** モーダル内など、上下の罫線のみで区切る */
  if (type == 'modal') {
    return (
      <div className='bg-fill-ai-secondary relative flex h-full w-full flex-col items-center justify-center overflow-hidden px-6 pt-4 pb-6'>
        <span className={clsx('absolute inset-x-0 top-0 h-px', AI_LINE_CLASS)} aria-hidden='true' />
        <span
          className={clsx('absolute inset-x-0 bottom-0 h-px', AI_LINE_CLASS)}
          aria-hidden='true'
        />
        <AiShine />
        <div className='relative'>{children}</div>
      </div>
    )
  }

  /** 領域全体をAIグラデーションの枠線で囲う。
      1pxの枠線は、グラデーションを敷いた p-px の器で表現する */
  return (
    <div className={clsx('h-full w-full rounded-2xl p-px', AI_LINE_CLASS)}>
      <div className='bg-fill-ai-secondary relative flex h-full w-full flex-col items-center overflow-hidden rounded-[15px] px-6 py-16'>
        <AiShine />
        <div className='relative'>{children}</div>
      </div>
    </div>
  )
}

export default AiLoadingArea
